var _rect, _rect2, _path, _path2, _path3, _circle, _path4, _rect3, _path5, _path6, _path7, _circle2, _path8, _path9, _circle3, _circle4, _circle5, _circle6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle7, _circle8, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermsandcondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 20,
    fill: "#B2CDFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.783,
    y: 49.5033,
    width: 54,
    height: 53,
    rx: 4.5,
    transform: "rotate(10 146.783 49.5033)",
    fill: "#ECECEC",
    stroke: "#100C41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.39 72.4999L186.873 78.404",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.827 81.3632L185.311 87.2673",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.264 90.2265L183.747 96.1305",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.86,
    cy: 54.8281,
    r: 4.5,
    transform: "rotate(10 179.86 54.8281)",
    fill: "white",
    stroke: "#100C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.608 61.1437C169.369 61.281 169.286 61.5865 169.423 61.8261C169.56 62.0657 169.866 62.1487 170.105 62.0114L169.608 61.1437ZM176.385 57.2616L169.608 61.1437L170.105 62.0114L176.882 58.1293L176.385 57.2616Z",
    fill: "#100C41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 27.5,
    width: 54,
    height: 53,
    rx: 4.5,
    fill: "#ECECEC",
    stroke: "#100C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111 49H145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111 58H145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67H145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 27,
    r: 4.5,
    fill: "white",
    stroke: "#100C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125 35C124.788 35.1768 124.759 35.492 124.936 35.7042C125.113 35.9163 125.428 35.945 125.64 35.7682L125 35ZM131 30L125 35L125.64 35.7682L131.64 30.7682L131 30Z",
    fill: "#100C41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90.5C49.9624 90.5 47.5 92.9624 47.5 96V221C47.5 224.038 49.9624 226.5 53 226.5H142C145.038 226.5 147.5 224.038 147.5 221V96C147.5 92.9624 145.038 90.5 142 90.5H53Z",
    fill: "white",
    stroke: "#100C41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 135.5,
    r: 7,
    fill: "#B2CDFC",
    stroke: "#100C41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 158.5,
    r: 7,
    fill: "#B2CDFC",
    stroke: "#100C41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 181.5,
    r: 7,
    fill: "#B2CDFC",
    stroke: "#100C41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 204.5,
    r: 7,
    fill: "#B2CDFC",
    stroke: "#100C41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 112,
    x2: 126,
    y2: 112,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 131,
    x2: 138,
    y2: 131,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 154,
    x2: 138,
    y2: 154,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 177,
    x2: 138,
    y2: 177,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 200,
    x2: 138,
    y2: 200,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 139,
    x2: 116,
    y2: 139,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 162,
    x2: 116,
    y2: 162,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 185,
    x2: 116,
    y2: 185,
    stroke: "#100C41",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 208,
    x2: 116,
    y2: 208,
    stroke: "#100C41",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 197,
    r: 31,
    fill: "#B0BEC5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 197,
    r: 31,
    fill: "#3ECF7A",
    stroke: "#100C41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150 196L160.5 205L175.5 189",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsandcondition);
export default __webpack_public_path__ + "static/media/terms and condition.def6a738ec157f51187787b12fc0d102.svg";
export { ForwardRef as ReactComponent };